import {
  AddManagedProviderBody,
  AddManagedProviderResponse,
  AssociationHistoryEntry,
  InviteManagedProviderResponse,
  NpiLookupResult,
  ProviderEmployerAssociation,
  ProviderEmployerInvitation,
} from '~/types';
import { deleteData, getData, postData } from '~/utils/service';

export const getAssociations = async (employerId: number) => {
  return getData<ProviderEmployerAssociation[]>('providerAssociations', {
    pathParams: { employer_id: String(employerId) },
  });
};

// [MCV-1826] Ends a provider's association from the employer side. [MCV-1927] For an
// unclaimed employer-managed vault the server archives the vault instead.
export const removeAssociation = async (employerId: number, associationId: number) => {
  return deleteData('providerAssociations', {
    pathParams: {
      employer_id: String(employerId),
      association_id: String(associationId),
    },
  });
};

// [MCV-1927] Providers whose association has ended, newest first.
export const getAssociationHistory = async (employerId: number) => {
  return getData<AssociationHistoryEntry[]>('providerAssociationHistory', {
    pathParams: { employer_id: String(employerId) },
  });
};

export const getInvitations = async (employerId: number) => {
  return getData<ProviderEmployerInvitation[]>('providerAssociationInvitations', {
    pathParams: { employer_id: String(employerId) },
  });
};

export const sendInvitation = async (email: string, npiNum?: string) => {
  return postData<{ id: number; invitationCode: string; status: string }>(
    'providerAssociationInvite',
    { data: npiNum ? { email, npiNum } : { email } }
  );
};

// [MCV-1894] Employer-managed vaults.
export const lookupProviderByNpi = async (npi: string) => {
  return getData<NpiLookupResult>('providerLookupByNpi', { pathParams: { npi } });
};

export const addManagedProvider = async (body: AddManagedProviderBody) => {
  return postData<AddManagedProviderResponse>('providerAddManaged', { data: body });
};

export const inviteManagedProvider = async (associationId: number, email: string) => {
  return postData<InviteManagedProviderResponse>('providerInviteManaged', {
    pathParams: { association_id: String(associationId) },
    data: { email },
  });
};

export const revokeInvitation = async (employerId: number, invitationId: number) => {
  return deleteData('providerAssociationInvitations', {
    pathParams: {
      employer_id: String(employerId),
      invitation_id: String(invitationId),
    },
  });
};

export const resendInvitation = async (employerId: number, invitationId: number) => {
  return postData<ProviderEmployerInvitation>('providerAssociationInvitationResend', {
    pathParams: {
      employer_id: String(employerId),
      invitation_id: String(invitationId),
    },
  });
};
